import { signalStore, type, withHooks, withState } from '@ngrx/signals';
import { entityConfig, withEntities } from '@ngrx/signals/entities';
import { Bmi, BmiApi } from '@types-lib';
import { withBmiStoreComputed } from './bmi-store-computed.feature';
import { withBmiStoreMethods } from './bmi-store-methods.feature';
import { withBmiStoreProps } from './bmi-store-props.feature';
import { withBmiStoreResources } from './bmi-store-resources.feature';
import { baseBmiInitialState } from './bmi-store.state';
import { withResourcePolling } from '@shared-utils';

export const bmiItemConfig = entityConfig({
  entity: type<BmiApi.UserBMI>(),
  collection: Bmi.BmiEntitiesEnum.COLLECTION_NAME,
  selectId: bmiItem => bmiItem.order.mail_order_fill_request_id,
});

export const BmiStore = signalStore(
  { providedIn: 'root' },
  withEntities<BmiApi.UserBMI>(bmiItemConfig),
  withState(baseBmiInitialState as Bmi.BmiStoreState),
  withResourcePolling(),
  withBmiStoreProps(),
  withBmiStoreComputed(),
  withBmiStoreResources(),
  withBmiStoreMethods(),
  withHooks({
    onDestroy(store) {
      store.loadBmiData.destroy();
      store.loadBmiData.destroy();
      store.updateBmiItem.destroy();
    },
  }),
);
